import { CurrencyList } from 'utils/constants/app/curreny-list';
import SpringConfigs from 'utils/constants/swarm/spring-configs';

type placementListType = {
  default: 'left' | 'right';
  left: 'left';
  right: 'right';
};

const getPlacement = (
  currencyPlacement: 'left' | 'right'
): 'left' | 'right' => {
  const placementList: placementListType = {
    default: currencyPlacement,
    left: 'left',
    right: 'right'
  };

  return placementList[SpringConfigs.CURRENCY_PLACEMENT];
};

export const currencyFormat = (
  currencyCode = ''
): { currency: string; placement: 'left' | 'right' } => {
  if (currencyCode) {
    const currencyData = CurrencyList[currencyCode];

    if (currencyData) {
      if (SpringConfigs.CURRENCIES_WITH_SYMBOLS) {
        return {
          currency: currencyData.symbol,
          placement: getPlacement(currencyData.placement)
        };
      } else {
        return {
          currency: currencyCode,
          placement: getPlacement(currencyData.placement)
        };
      }
    } else {
      return { currency: currencyCode, placement: 'right' };
    }
  }

  return { currency: currencyCode, placement: 'right' };
};

export const formatPlacement = (
  currency: string,
  placement: 'left' | 'right'
): ((amount: number | string, showCurrency?: boolean) => string) => {
  return function (amount, showCurrency) {
    return showCurrency === false
      ? `${amount}`
      : placement === 'left'
      ? `${currency} ${amount}`
      : `${amount} ${currency}`;
  };
};

export const formatAmountWithCurrency = (
  currency: string,
  amount: number | string
): string => {
  return formatPlacement(
    currencyFormat(currency).currency,
    currencyFormat(currency).placement
  )(amount);
};
